import { writable } from 'svelte/store';

export const detailOnly = writable(0);

export const isSingleView = writable(0);

export const modal = writable(0);